export default __webpack_public_path__ + "img/BVkdfqhz.c5d66aab.svg";